import React from 'react';
import { Box, Container } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link, Redirect } from 'react-router-dom';
import { ROUTING_CONFIG, supportArticleRoute } from '@uplift/constants';
import { Button, ProviderLayout, ProviderLayoutPageHeader, ProviderLayoutPageTitle } from '@uplift/ui-v2';
import { getSupportArticleBySlug } from './articles';
import { useSupportArticleStyles } from './articles/article-shared';

export const SupportArticlePage = () => {
  const { slug } = supportArticleRoute.useParams();
  const article = getSupportArticleBySlug(slug);
  const { classes } = useSupportArticleStyles();

  if (!article) {
    return <Redirect to={ROUTING_CONFIG.support} />;
  }

  const ArticleContent = article.Component;

  return (
    <ProviderLayout>
      <ProviderLayoutPageHeader
        title={(
          <Box>
            <Button
              component={Link}
              to={ROUTING_CONFIG.support}
              color="secondary"
              startIcon={<ArrowBack />}
              sx={{ mb: 1, px: 0 }}
            >
              Back to Help Center
            </Button>
            <ProviderLayoutPageTitle title={article.title} />
          </Box>
        )}
      />
      <Container className={classes.content}>
        <ArticleContent />
      </Container>
    </ProviderLayout>
  );
};
